module.exports = __webpack_public_path__ + "static/img/bg36.3a1c74d5.png";